<template>
  <div>
    <transition name="fade">
      <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isProductLoading">
        <grid-loader :loading="isProductLoading" :size="loaderSize"></grid-loader>
      </div>
    </transition>
    <div class="row m-0" v-if="!isProductLoading && this.products === 0">
      <div class="col-12 text-center mt-5">
        <h3>There are no products available at the moment.</h3>
      </div>
    </div>
    <div class="row m-0" v-else>
      <div class="col-12 category_menu my-3 p-0 pl-md-3 pr-md-0">
        <div class="row m-0 h-100">
          <div class="col-12 p-0 pl-md-2">
            <div class="row m-0 h-100">
              <div class="col-2 col-md-3 h-100 pt-1 pl-md-0 border_top" :class="{'bg_color': categories && categories.length > 1, 'bg_color': position != 'top'}">
                <search-menu @search="filterSearch"></search-menu>
              </div>
              <div class="col-10 col-md-9 h-100 px-0 border_top" :class="{'bg_color': categories && categories.length > 1, 'bg_color': position != 'top'}">
                <div class="row m-0 h-100">
                  <div class="col-12 h-100 pl-0">
                    <div class="row flex-row flex-nowrap h-100 overflow_x" v-if="categories && categories.length > 1">
                      <category-item v-for="cat in activeCategories" :categoryItem="cat" :key="cat.id" @selectCategory="selectCategory" :selected="categoryFilter"></category-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-lg-9 p-0 px-md-3">
        <products-page v-for="(prod, key) in productsGroupedByCategory" :key="key" :categoryItem="key" :products="prod" :search="search"></products-page>
        <!-- <div class="row m-0">
          <app-product-item v-for="prod in filteredProducts" :item="prod" :key="prod.id" :displayList="displayList"></app-product-item>
        </div> -->
      </div>
      <div class="col-md-4 col-lg-3 pr-0 d-none d-md-flex sidebar_cart h-100">
        <div class="card w-100 p-3">
          <div class="row m-0" v-if="cartItemList.length > 0">
            <div class="col-12 p-0 mb-2">
              <h4>Cart</h4>
            </div>
            <div class="col-12 p-0 small_text mb-2 pb-2 border_bottom"
              v-for="cartItem in cartItemList"
              :key="cartItem.id"
            >
              <div class="row m-0">
                <div class="col-12 p-0">
                  <div class="row m-0 align-items-center h-100">
                    <div class="col-2 pl-0 pr-2">
                      <!-- <span v-if="isCheckout">{{cartItem.quantity}}</span> -->
                      <input type="number" class="form-control text-center p-0"
                        :value="cartItem.quantity"
                        @input="updateQuantity(cartItem)"
                        min="0"
                      >
                    </div>
                    <div class="col-8 px-0">
                      <b class="truncate">{{ cartItem.title }}</b>
                    </div>
                    <div class="col-2 p-0 text-right">
                      <b class="mb-0">R {{ cartItem.quantity * cartItem.price }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 p-0">
              <router-link to="/cart" class="btn btn-outline w-100" tag="button" v-if="isLoggedIn">
                Checkout <span class="badge">{{ numItems }} (R {{ cartValue }})</span>
              </router-link>
              <button @click="login" class="btn btn-outline w-100" v-else>
                Checkout <span class="badge">{{ numItems }} (R {{ cartValue }})</span>
              </button>
            </div>
          </div>
          <div class="row m-0" v-else>
            <div class="col-12 p-0 text-center">
              <b>Your cart is empty</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  name: 'Store',
  props: ['position'],
  data () {
    return {
      loaderSize: '50px',
      displayList: false,
      search: '',
      categoryFilter: ''
    }
  },
  metaInfo () {
    if (this.shopDetails && this.shopDetails.name) {
      return {
        title: `${this.shopDetails.name}`,
        meta: [
          { name: 'description', content: `${this.shopDetails.description}` },
          {
            property: 'fb:app_id',
            content: '2744358572336800'
          },
          { property: 'og:title', content: `${this.shopDetails.name}` },
          {
            property: 'og:description',
            content: `${this.shopDetails.description}`
          },
          { property: 'og:type', content: 'website' },
          {
            property: 'og:image',
            content: `${this.shopDetails.logo}`
          },
          {
            property: 'og:url',
            content: `https://${this.shopDetails.domain}.thehoods.app/`
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'products', 'isProductLoading', 'shopDetails', 'cartItemList', 'cartValue', 'categories']),
    numItems () {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity
        return total
      }, 0)
    },
    productsGroupedByCategory () {
      let list = {}
      if (this.products.length < 4) {
        list.uncategorised = this.products
      } else if (this.products.length > 0) {
        list.uncategorised = this.products.filter((product) => typeof product.category === 'undefined')
        this.categories.forEach((category) => {
          this.products.forEach((product) => {
            if (typeof product.category !== 'undefined' && product.category === category) {
              if (typeof list[product.category] === 'undefined') {
                list[product.category] = []
              }
              list[product.category].push(product)
            }
          })
        })
      }
      return list
    },
    activeCategories () {
      var active = []
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories.indexOf(this.categories[i]) > -1) {
          var stringVal = this.categories[i]
          var newStringVal = stringVal.replace(/ /g, '')
          var category = {
            id: newStringVal,
            cat: stringVal
          }
          active.push(category)
        }
      }
      return active
    }
  },
  watch: {
    shopDetails () {
      if (this.shopDetails && this.shopDetails.name) {
        this.$meta().refresh()
      }
    },
    isProductLoading () {
      if (!this.isProductLoading && this.products === 0) {
        console.log('redirectiing')
        // setTimeout(() => this.$router.push({ path: '/landing' }), 5000)
      }
    }
  },
  mounted () {
    if (this.$route.params.storeId) {
      this.setShopId(this.$route.params.storeId)
    }
  },
  components: {
    GridLoader,
    'search-menu': () => import('@/components/common/Search.vue'),
    'category-item': () => import('@/components/CategoryMenuItem.vue'),
    'products-page': () => import('@/components/product/ProductsPage.vue')
  },
  methods: {
    ...mapActions(['updateCart', 'removeItemInCart', 'setShopId']),
    changeDisplay (isList) {
      this.displayList = isList
    },
    removeItem () {
      let vm = this
      this.removeItemInCart({
        item: vm.cartItem
      })
    },
    login () {
      this.$emit('login')
    },
    filterSearch (val) {
      this.search = val
    },
    selectCategory (val) {
      this.categoryFilter = val
    },
    updateQuantity (cartItem) {
      this.updateCart({
        item: cartItem,
        quantity: parseInt(event.target.value),
        isAdd: false
      })
    }
  }
}
</script>

<style>
.small_text {
  font-size: 0.8rem;
  line-height: 1;
}
.border_bottom {
  border-bottom: 1px solid var(--light-color-off);
}
.dark-mode .border_bottom {
  border-bottom: 1px solid var(--light-color-01);
}
.small_text .truncate {
    word-wrap: break-word;
    overflow-y: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 2;
  }
.small_text .form-control {
  font-size: 0.8rem;
}
.category_menu {
  height: 50px;
  position: sticky;
  top: 80px;
  z-index: 9;
}
.border_top {
  border-top: 1px solid transparent;
}
.bg_color {
  border-top: 1px solid var(--dark-color-off);
  /* margin-left: -1px; */
}
.dark-mode .bg_color {
  border-top: 1px solid var(--light-color-off);
  border-left: 1px solid var(--dark-color-off)
}
.overflow_x  {
  overflow-x: auto;
}
@media (min-width: 768px) {
  .category_menu {
    top: 50px;
  }
  .sidebar_cart {
    position: sticky;
    top: 120px;
    z-index: 9;
    bottom: inherit;
    width: 100%;
    max-height: calc(100vh - 120px);
  }
}
</style>
